import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PrimeNgTranslationsService {

	constructor () { }

	getTranslations () {
		return {
			dayNames: [
				$localize`:@@common.day-name.sun:Sunday`,
				$localize`:@@common.day-name.mon:Monday`,
				$localize`:@@common.day-name.tue:Tuesday`,
				$localize`:@@common.day-name.wed:Wednesday`,
				$localize`:@@common.day-name.thu:Thursday`,
				$localize`:@@common.day-name.fri:Friday`,
				$localize`:@@common.day-name.sat:Saturday`
			],
			dayNamesMin: [
				$localize`:@@common.day-name-min.su:Su`,
				$localize`:@@common.day-name-min.mo:Mo`,
				$localize`:@@common.day-name-min.tu:Tu`,
				$localize`:@@common.day-name-min.we:We`,
				$localize`:@@common.day-name-min.th:Th`,
				$localize`:@@common.day-name-min.fr:Fr`,
				$localize`:@@common.day-name-min.sa:Sa`
			],
			dayNamesShort: [
				$localize`:@@common.day-name-short.sun:Sun`,
				$localize`:@@common.day-name-short.mon:Mon`,
				$localize`:@@common.day-name-short.tue:Tue`,
				$localize`:@@common.day-name-short.wed:Wed`,
				$localize`:@@common.day-name-short.thu:Thu`,
				$localize`:@@common.day-name-short.fri:Fri`,
				$localize`:@@common.day-name-short.sat:Sat`
			],
			monthNames: [
				$localize`:@@common.month-name.jan:January`,
				$localize`:@@common.month-name.feb:February`,
				$localize`:@@common.month-name.mar:March`,
				$localize`:@@common.month-name.apr:April`,
				$localize`:@@common.month-name.may:May`,
				$localize`:@@common.month-name.jun:June`,
				$localize`:@@common.month-name.jul:July`,
				$localize`:@@common.month-name.aug:August`,
				$localize`:@@common.month-name.sep:September`,
				$localize`:@@common.month-name.oct:October`,
				$localize`:@@common.month-name.nov:November`,
				$localize`:@@common.month-name.dec:December`
			],
			monthNamesShort: [
				$localize`:@@common.month-name-short.jan:Jan`,
				$localize`:@@common.month-name-short.feb:Feb`,
				$localize`:@@common.month-name-short.mar:Mar`,
				$localize`:@@common.month-name-short.apr:Apr`,
				$localize`:@@common.month-name-short.may:May`,
				$localize`:@@common.month-name-short.jun:Jun`,
				$localize`:@@common.month-name-short.jul:Jul`,
				$localize`:@@common.month-name-short.aug:Aug`,
				$localize`:@@common.month-name-short.sep:Sep`,
				$localize`:@@common.month-name-short.oct:Oct`,
				$localize`:@@common.month-name-short.nov:Nov`,
				$localize`:@@common.month-name-short.dec:Dec`
			],
			today: $localize`:@@common.today:Today`,
			clear: $localize`:@@common.clear:Clear`,
			accept: $localize`:@@common.yes:Yes`,
			reject: $localize`:@@common.no:No`,
		};
	};
}